export const EVENTS = [
    "started",
    "in_progress",
    "api_failure",
    "aborted",
    "failed",
    "finished",
    "benchmark_passed",
    "benchmark_failed"
];

export const WEBHOOK_TYPES = [
    'json','slack'
]